// extracted by mini-css-extract-plugin
module.exports = {"container":"information-step-module__container___3oz18","removeProject":"information-step-module__removeProject___aEATy"};